module.exports = __webpack_public_path__ + "static/thumbnail_hover-c6521b6b3981a454eb335b9a0c43b1a1.png";